module.exports = __webpack_public_path__ + "img/Techweek-logo.fb37b70a.jpg";